import React from 'react';
export function Footer() {
  return <footer className="bg-[#0a0a0a] border-t border-[#1a1a1a] py-16 relative z-10" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <div className="flex flex-col items-center space-y-8" data-id="element-165">
          <div className="flex items-center space-x-4 opacity-80 hover:opacity-100 transition-opacity" data-id="element-166">
            <img src="https://cdn.magicpatterns.com/uploads/qVSgAWpQyG1QENGutcuqdx/ChatGPT_Image_21_jun_2026,_22_59_42.png" alt="UnsolvedNights logo" className="h-12 w-12 object-contain filter drop-shadow-[0_0_8px_rgba(236,227,208,0.3)]" data-id="element-167" />
            <span className="font-typewriter text-xl text-[#ece3d0] tracking-widest" data-id="element-168">
              UnsolvedNights
            </span>
          </div>

          <p className="font-serif-body text-[#ece3d0]/60 text-xl italic text-center max-w-md" data-id="element-169">
            "The truth is out there. Tonight, you find it."
          </p>

          <div className="w-12 h-px bg-[#8b1a1a]/30" data-id="element-170" />

          <div className="text-xs text-[#ece3d0]/30 font-typewriter tracking-widest uppercase" data-id="element-171">
            © 2026 UnsolvedNights. All rights reserved.
          </div>
        </div>
      </div>
    </footer>;
}